import Vue from "vue";
// 验证身份证号码
export function validCode(rule, value, callback) {
  if (value !== "") {
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (!reg.test(value)) {
      return callback(new Error("身份证号码格式不正确"));
    }
  }
  callback();
}
// 验证中英文名称
export function validName(rule, value, callback) {
  if (value !== "") {
    const reg = /^[\u4E00-\u9FA5A-Za-z\s]+(·[\u4E00-\u9FA5A-Za-z]+)*$/;
    if (!reg.test(value)) {
      return callback(new Error("姓名由中文、英文组成"));
    }
  }
  callback();
}
// 验证手机号
export function validPhone(value, callback) {
  if (value !== "") {
    const reg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
    if (!reg.test(value)) {
      return callback(new Error("手机号格式不正确"));
    }
  }
  callback();
}
// 验证车牌号
export function validCarCode(rule, value, callback) {
  if (value !== "") {
    // const reg = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
    const reg = /([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}(([A-HJ-Z]{1}[A-HJ-NP-Z0-9]{5})|([A-HJ-Z]{1}(([DF]{1}[A-HJ-NP-Z0-9]{1}[0-9]{4})|([0-9]{5}[DF]{1})))|([A-HJ-Z]{1}[A-D0-9]{1}[0-9]{3}警)))|([0-9]{6}使)|((([沪粤川云桂鄂陕蒙藏黑辽渝]{1}A)|鲁B|闽D|蒙E|蒙H)[0-9]{4}领)|(WJ[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼·•]{1}[0-9]{4}[TDSHBXJ0-9]{1})|([VKHBSLJNGCE]{1}[A-DJ-PR-TVY]{1}[0-9]{5})/;
    if (!reg.test(value)) {
      return callback(new Error("车牌号不正确"));
    }
  }
  callback();
}
// 验证是否是外部链接
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

const validate = {
  /* 密码 */
  _password: /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,20}$/,
  password(rule, value, callback) {
    // const reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,20}$/;
    const reg = validate._password;

    if (!reg.test(value)) {
      return callback(
        new Error("密码必须为8~20个字符,至少包含数字,字母,标点符号 任意两种")
      );
    }

    callback();
  },

  /* 手机号 */
  _mobilePhone: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
  mobilePhone(rule, value, callback) {
    const reg = validate._mobilePhone;

    if (!reg.test(value)) {
      return callback(new Error("请输入正确的手机号。"));
    }

    callback();
  },

  /* 固话 */
  _telephone: /0\d{2,3}-\d{7,8}/,
  telephone(rule, value, callback) {
    const reg = validate._telephone;

    if (!reg.test(value)) {
      return callback(new Error("座机号码格式不正确，请输入正确的座机号码。"));
    }

    callback();
  },

  /* 纯汉字 */
  _isChinese: /^[\u4e00-\u9fa5]+$/,
  isChinese(rule, value, callback) {
    const reg = validate._isChinese;

    if (!reg.test(value)) {
      return callback(new Error("请输入中文字符。"));
    }

    callback();
  },

  /* 纯数字 */
  _isNumber: /^[0-9]+$/,
  isNumber(rule, value, callback) {
    const reg = validate._isNumber;

    if (!reg.test(value)) {
      return callback(new Error("请输入数字字符。"));
    }

    callback();
  },

  /* 纯字母 */
  _isEnglish: /^[A-Za-z]+$/,

  /* 身份证号 */
  _idCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  idCard(rule, value, callback) {
    const reg = validate._idCard;

    if (!reg.test(value)) {
      return callback(new Error("身份证格式不正确，请输入正确的身份证号"));
    }

    callback();
  },

  /* 字符(汉字+) */
  _character: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
  character(rule, value, callback) {
    const reg = validate._character;

    if (!reg.test(value)) {
      return callback(new Error("请输入中英文字符。"));
    }

    callback();
  },

  /* 版本号 */
  _version: /^[0-9]{0,3}\.[0-9]{0,3}\.[0-9]{0,3}$/,
  version(rule, value, callback) {
    const reg = validate._version;

    if (!reg.test(value)) {
      return callback(new Error("版本号格式不正确，请输入正确的版本号"));
    }

    callback();
  },

  /* 用户名：由数字、英文（包括全角字符）、下划线组成，并以字母开头 */
  _loginName: /^[a-zA-Z]([_a-zA-Z0-9]{1,19})$/,
  loginName(rule, value, callback) {
    const reg = validate._loginName;

    if (!reg.test(value)) {
      return callback(
        new Error(
          "用户名为2~20个字符，且由数字、英文（包括全角字符）、下划线组成，并以字母开头"
        )
      );
    }

    callback();
  },

  /* 只能输入字母和数字的组合 */
  _isNotChinese: /^[0-9a-zA-Z]*$/g,
  isNotChinese(rule, value, callback) {
    const reg = validate._isNotChinese;
    console.log(reg.test(value));
    if (!reg.test(value)) {
      return callback(
          new Error("应用标识为字母和数字的组合")
          );
    }

    callback();
  },

  /* 姓名：2-20个字符，支持中英文（包括全角字符）、数字、下划线 （全角及汉字算两位）,中文按二位计数 */
  _userName: /^[\u4E00-\u9FA5\w\d]{2,20}$/,
  userName(rule, value, callback) {
    const reg = validate._userName;

    if (!reg.test(value)) {
      return callback(
        new Error(
          "姓名为2~20个字符，且由数字、中英文（包括全角字符）、下划线组成"
        )
      );
    }

    callback();
  },

  /* 编码: 由数字、26个英文字母或者下划线组成的字符串 */
  _code: /^\w+$/,

  /* ip地址 */
  _ip: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,

  /* 端口号 */
  _port: /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/
};

Vue.prototype.regExp = validate;
